import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

const VenueAddModal = ({ onClose, getDataFromServer }) => {
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const [formData, setFormData] = useState({
    venue_name: null,
    description: null,
    church_id: user?.church_id,
    createdBy: user?._id,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleVenueRegistration = (e) => {
    e.preventDefault();

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/venues/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: formData,
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        toast.success("Venue Created Successfully.");
        getDataFromServer();
        onClose();
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "CreateVenueChild", "/venues/");
        // console.log(error);
      });
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-full p-4" style={{ wordBreak: "break-word" }}>
        {/* {JSON.stringify(formData)} */}
        <div className="p-6">
          <h2 className="mb-4 text-xl font-semibold">Add New Venue</h2>
          <form onSubmit={handleVenueRegistration} autoComplete="off">
            <div className="mb-4">
              <label
                htmlFor="venue_name"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                Venue Name
              </label>
              <input
                type="text"
                id="venue_name"
                name="venue_name"
                value={formData.venue_name || ""}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="description"
                className="block mb-1 text-sm font-medium text-gray-700"
              >
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description || ""}
                onChange={handleChange}
                rows="4"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="flex justify-end w-full mt-4">
              <button
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-900"
                type="submit"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VenueAddModal;
